export default __webpack_public_path__ + "static/exGraff-da13f416b03ef4c1d500b77ffd7f1fac.webp";